import { render, staticRenderFns } from "./IconPresetOwn.vue?vue&type=template&id=68083c26&scoped=true&"
import script from "./IconPresetOwn.vue?vue&type=script&lang=js&"
export * from "./IconPresetOwn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68083c26",
  null
  
)

export default component.exports